export function extractScrapeJobError(upstreamBody: string, statusText = '') {
  let parsed: unknown = upstreamBody;
  try {
    parsed = JSON.parse(upstreamBody);
  } catch {
    // keep raw text
  }

  let message = upstreamBody || statusText;
  if (parsed && typeof parsed === 'object') {
    if (
      'message' in parsed &&
      typeof parsed.message === 'string' &&
      parsed.message
    ) {
      message = parsed.message;
    } else if (
      'error' in parsed &&
      typeof parsed.error === 'string' &&
      parsed.error
    ) {
      message = parsed.error;
    } else {
      message = JSON.stringify(parsed);
    }
  }

  return { message, parsed };
}
